import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["primaryCalendarId"];

  broadcastPrimaryCalendarChange() {
    this.dispatch('changed', { detail: { primaryCalendarId: this.primaryCalendarIdTarget.value }, bubbles: true });
  }
}
